module.exports = __webpack_public_path__ + "img/security-guard.781c5161.svg";